import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import SignUpDataService from '../../../../services/SignUpDataService';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { setIsUserAuthenticated } from '../../authentication/AuthenticationSlice';
import { PAGE_STATE } from '../../constants/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { PRE_LOGIN_LOADING_STATES } from '../constants';
import { componentKey, resetSignUpPage, setEmailCanBeUsed, setLoadingState, setSignUpFormErrors, setSignedUpUserData } from './SignUpSlice';
import SignInDataService from '../../../../services/SignInDataService';

export const { validateEmailExists, signUpUser, signUpWThirdParty } = {
    validateEmailExists: (payload) => {
        return {
            type: "SIGN_UP/VALIDATE_EMAIL_EXISTS",
            payload: payload
        }
    },
    signUpUser: (payload) => {
        return {
            type: "SIGN_UP/SIGN_UP_USER",
            payload: payload
        }
    },
    signUpWThirdParty: (payload) => {
        return {
            type: "SIGN_UP/SIGN_UP_WITH_THIRD_PARTY",
            payload: payload
        }
    },
}

function* validateEmailExistsAsync(action){
    try{
        yield put(setSignUpFormErrors({
            emailErrorStatus: false,
            emailErrorMessage: "",
        }));
        const response = yield SignUpDataService.validateEmailExists(action.payload);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(setEmailCanBeUsed(false));
                yield put(setSignUpFormErrors({
                    emailErrorStatus: true,
                    emailErrorMessage: response.data.Message,
                }));
            }else{
                yield put(setSignUpFormErrors({
                    emailErrorStatus: false,
                    emailErrorMessage: "",
                }));
                yield put(setEmailCanBeUsed(true));
            }
        }    
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }
}

function* signUpUserAsync(action) {
    try {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SIGN_UP_PAGE_LOADING}));
        yield put(setSignUpFormErrors({signUpErrorStatus: false, signUpErrorMessage: ""}));
        const response = yield SignUpDataService.signUp(action.payload);
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(setSignUpFormErrors({signUpErrorStatus: true, signUpErrorMessage: response.data.Message}));
            }else{
                yield put(setIsUserAuthenticated(true));
                yield put (setSignedUpUserData({ EncUID : response?.data?.Data?.EncUID, Email: response.data.Data.Email }))
                yield put(resetSignUpPage());
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SIGN_UP_PAGE_READY}));
    }
}

function* signUpWThirdPartyAsync(action){
    try {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SSO_SIGN_UP_PAGE_LOADING, message: "Signing up..." }));
        const response = yield SignInDataService.loginWThirdParty(action.payload);
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setIsUserAuthenticated(true));
        } else {
            yield put(addNotifications({
                heading: "Error",
                message: "An issue occurred while processing your request. Please try again.",
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: "An issue occurred while processing your request. Please try again.",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SSO_SIGN_UP_PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(validateEmailExists().type, validateEmailExistsAsync),
        takeLatest(signUpUser().type, signUpUserAsync),
        takeLatest(signUpWThirdParty().type, signUpWThirdPartyAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);